import {
  updateCartCount,
  messages,
  checkIsAutoFilled,
  initAjaxFormValidation,
  gtagTrack,
} from './common';
import {Tooltip}  from "bootstrap";

$(function () {
  [...$("[data-bs-toggle='tooltip']")].forEach(el => {
    new Tooltip(el);
  });

  initAjaxFormValidation();

  const $denomIdInput = $('input[name=denom_id]').first();
  if ($denomIdInput.length !== 0) { gtagTrack('view_item', $denomIdInput.data('gtag')); }

  const $rtrDenomIdInput = $('input[name="rtr_purchase_form[denom_id]"]').first();
  if ($rtrDenomIdInput.length !== 0) { gtagTrack('view_item', $rtrDenomIdInput.data('gtag')); }

  if (typeof (JsBarcode) !== 'undefined' && $('svg.barcode')) {
    try {
      JsBarcode("svg.barcode").init();
    } catch (e) {
      $('.barcode-wrapper, .barcode-or').addClass('d-none');
    }
  }

  $('#rtg-add').each(function() {
    const that = $(this);
    $("input:submit", that).bind("click keypress", function () {
      that.data("caller", this.name);
    });
  }).bind('submit', function(e) {
    e.preventDefault();
    const code = $(this).find('input[data-target="code"]').val();
    const tel = $(this).find('input[data-target="phone"]').val();
    const  message = `Please confirm that ${code} ${tel} is the correct phone number.`

    return confirm(message);
  // }).on('ajax:beforeSend', () => {
  //   $(this).find('input, select').attr('disabled', 'disabled');
  // })
  // .on('ajax:complete', () => {
  //   $(this).find('input, select').removeAttr('disabled');
  })
  .on('ajax:success', (e) => {
    const response = e.originalEvent.detail && e.originalEvent.detail[0];
    const $el = $(e.target)
    const data = $el.data();

    if (response && response.message === 'success') {
      const $btn = $el.find(`input[name="${data.caller}"]`);
      const $denom = $('input[name="rtr_purchase_form[denom_id]"]').filter(':checked').first();
      gtagTrack(data.caller, $denom.data('gtag'));


      if (data.caller === 'add_to_cart') {
        updateCartCount(1);
        $('.cart-add')
          .attr('disabled', 'disabled')
          .addClass('cart-add_added');
      } else {
        window.location.href = window.location.href.replace(/products\S+$/i, 'cart');
      }
    } else {
      alert(response && response.message || 'Something went wrong. Please try again');
    }
  })
  .on('ajax:error', (e) => {
    const response = e.originalEvent.detail && e.originalEvent.detail[0];

    alert(response && response.message || 'Something went wrong. Please try again');
  });


  const $combobox = $('.bs-combobox');
  if ($combobox.length) {
    $combobox.each(function () {
      const data = $(this).data();
      $(this).selectpicker({
        width: '100%',
        liveSearch: true,
        liveSearchNormalize: true,
        liveSearchPlaceholder: data.placeholder || 'Type to search',
        noneSelectedText: data.nothing_selected || (messages && messages.nothing_selected) || 'Nothing selected',
        selectedTextFormat: 'count > 3',
        maxOptions: 5,
        hideDisabled: true,
      });
    });
  }

  $('#js-checkout-btn').on('click', function (e) {
    e.preventDefault();

    const $form = $(this).closest('form');
    const $errors = $form.find('.errored-text');
    const containErrors = $errors.length ? !![...$errors].map(item => item.innerHTML).join().replace(/\n|\s|,/gi,'') : false;

    // prevent re-submit if form already contains errors
    if (!containErrors) {
      $('.js-product').each(function () {
        gtagTrack('begin_checkout', $(this).data('gtag'));
      });
    }

    setTimeout(() => {
      $form.submit();
    }, 300);
  });

  $('button[type="reset"]').on('click', function (e) {
    e.preventDefault();

    $('input[type="checkbox"]')
      .removeAttr('checked')
      .prop('checked', false);

    $('option').removeAttr('selected');
    $combobox.val('default').selectpicker('refresh');

    $(this).closest('form').submit();
  });

  checkIsAutoFilled($('#order_form'), {
    fields: ['order[customer_attributes][email]'],
    target: 'order[autofilled]',
    success: () => {
      $('#order_form input[name="order[customer_attributes][email_confirmation]"]')
        .val($('#order_form input[name="order[customer_attributes][email]"]').val());
    },
    fail: () => {},
  });
});
